export default __webpack_public_path__ + "static/media/instacare-logo.e952a7bc.png";